import { ShapedLine } from '@bynder-studio/structured-text';
import { TextBackground } from '@bynder-studio/misc';

export const getNextVisibleLineIndex = <
    T extends { absBbox: { top: number; left: number; width: number; height: number } },
>(
    lines: T[],
    lineIdx: number,
) => {
    const line = lines?.[lineIdx];

    if (!line) {
        return -1;
    }

    return line.absBbox.width > 0 && line.absBbox.height > 0 ? lineIdx : getNextVisibleLineIndex(lines, lineIdx + 1);
};

export const getPrevVisibleLineIndex = <
    T extends { absBbox: { top: number; left: number; width: number; height: number } },
>(
    lines: T[],
    lineIdx: number,
) => {
    const line = lines?.[lineIdx];

    if (!line) {
        return -1;
    }

    return line.absBbox.width > 0 && line.absBbox.height > 0 ? lineIdx : getPrevVisibleLineIndex(lines, lineIdx - 1);
};

export const getShapedLinesBoxesWithBg = (lines: ShapedLine[], bg: TextBackground) => {
    if (!bg || !bg.isActive()) {
        return lines;
    }

    return lines.map((line) => {
        const {
            absBbox: { left, top, width, height },
        } = line;
        const isEmpty = !width || !height;

        return {
            absBbox: {
                left: left - bg.spacingLeft,
                top: top - bg.spacingTop,
                width: isEmpty ? width : width + bg.spacingLeft + bg.spacingRight,
                height: isEmpty ? height : height + bg.spacingTop + bg.spacingBottom,
            },
        };
    });
};
